import React from 'react';
import { UserStatus, getStatusOption } from '@/types/presence';
import { cn } from '@/lib/utils';

interface PresenceIndicatorProps {
  status: UserStatus;
  statusMessage?: string;
  size?: 'sm' | 'md' | 'lg';
  showLabel?: boolean;
  showMessage?: boolean;
  className?: string;
}

export const PresenceIndicator: React.FC<PresenceIndicatorProps> = ({
  status,
  statusMessage,
  size = 'md',
  showLabel = false,
  showMessage = false,
  className
}) => {
  const statusOption = getStatusOption(status);
  
  const sizeClasses = {
    sm: 'text-xs',
    md: 'text-sm',
    lg: 'text-base'
  };

  const iconSizes = {
    sm: 'text-sm',
    md: 'text-base',
    lg: 'text-lg'
  };

  const getStatusBackground = (status: UserStatus) => {
    const backgroundMap = {
      'available': 'bg-green-500',
      'busy': 'bg-orange-500', 
      'do_not_disturb': 'bg-red-500',
      'in_meeting': 'bg-blue-500',
      'away': 'bg-gray-500',
      'offline': 'bg-gray-400'
    };
    return backgroundMap[status] || 'bg-gray-400';
  };

  return (
    <div className={cn(
      'flex items-center gap-1.5 rounded-full px-3 py-1.5',
      getStatusBackground(status),
      className
    )}>
      {!showLabel && (
        <span className={cn("text-white", iconSizes[size])}>{statusOption.icon}</span>
      )}
      
      {showLabel && (
        <span className={cn(
          'font-medium text-white',
          sizeClasses[size]
        )}>
          {statusOption.label}
        </span>
      )}
      
      {showMessage && statusMessage && (
        <span className={cn(
          'text-white/90 truncate',
          sizeClasses[size]
        )}>
          - {statusMessage}
        </span>
      )}
    </div>
  );
};